import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";
import { useDomainWarp } from "./DomainWarpContext";

export function DomainWarpViewer() {
    const {
        viewBoxAttr,
        canvasW,
        canvasH,
        contourData,
        contourLevels,
        fillColor,
        strokeColor,
        bgColor,
        strokeWidth,
        fillShapes,
        canExport,
        handleDownload,
    } = useDomainWarp();

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    const totalPaths = contourData.reduce((n, l) => n + l.paths.length, 0);

    return (
        <div className="panel-viewer domain-warp-viewer">
            <div className="path-tool-preview">
                {/* Zoom controls */}
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>

                {/* Scrollable SVG */}
                <div className="svg-scroll-wrapper">
                    <div className="svg-container svg-container--fill">
                        <svg
                            ref={svgRef}
                            viewBox={viewBox}
                            xmlns="http://www.w3.org/2000/svg"
                            className="path-tool-svg"
                            style={{ touchAction: "none" }}
                            {...panHandlers}
                        >
                            <rect
                                x={0}
                                y={0}
                                width={canvasW}
                                height={canvasH}
                                fill={bgColor}
                            />

                            <g className="contours">
                                {contourData.map(({ paths, level }) => {
                                    const fillOpacity = fillShapes
                                        ? (level + 1) / contourLevels
                                        : 0;
                                    return paths.map((d, i) => (
                                        <path
                                            key={`c${level}-${i}`}
                                            d={d}
                                            fill={
                                                fillShapes ? fillColor : "none"
                                            }
                                            fillOpacity={fillOpacity}
                                            stroke={strokeColor}
                                            strokeWidth={strokeWidth}
                                        />
                                    ));
                                })}
                            </g>
                        </svg>
                    </div>
                </div>

                {/* Footer */}
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {totalPaths} contour path{totalPaths !== 1 ? "s" : ""}{" "}
                        across {contourLevels} level
                        {contourLevels !== 1 ? "s" : ""}. &nbsp;viewBox:{" "}
                        {canvasW} × {canvasH}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
